import { render, staticRenderFns } from "./MyMenteeModuleTasks.vue?vue&type=template&id=e64c52c6"
import script from "./MyMenteeModuleTasks.vue?vue&type=script&lang=js"
export * from "./MyMenteeModuleTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports